import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = makeStyles(() => ({
  container: {
    height: `100vh`,
  },
}))

export default function AppLoader() {
  const classes = styles()
  return (
    <Grid container alignItems="center" justify="center" className={classes.container}>
      <CircularProgress />
    </Grid>
  )
}
